module.exports = __webpack_public_path__ + "img/selfbio-logo-6.7a48429b.png";